<template>
    <!-- begin::Horizontal Menu -->
	<div class="m-stack__item m-stack__item--fluid m-header-menu-wrapper">
		<button class="m-aside-header-menu-mobile-close  m-aside-header-menu-mobile-close--skin-light " id="m_aside_header_menu_mobile_close_btn"><i class="la la-close"></i></button>
		<div id="m_header_menu" class="m-header-menu m-aside-header-menu-mobile m-aside-header-menu-mobile--offcanvas  m-header-menu--skin-dark m-header-menu--submenu-skin-light m-aside-header-menu-mobile--skin-light m-aside-header-menu-mobile--submenu-skin-light ">
			<ul class="m-menu__nav  m-menu__nav--submenu-arrow">
				<router-link :event="item.resource==''?'disabled':'click'" tag="li" :to="getMenuLink(item)" v-for="item in menuItems" active-class="m-menu__item--active m-menu__item--active-tab" class="m-menu__item m-menu__item--submenu m-menu__item--tabs" m-menu-submenu-toggle="tab" aria-haspopup="true">
					<a :href="getMenuLink(item)" class="m-menu__link m-menu__toggle">
						<i v-if="item.icon !== ''" :class="'m-menu__link-icon ' + item.icon"></i>
						<span class="m-menu__link-text">{{getMenuAlias(item)}}</span>
					</a>
					<div class="m-menu__submenu m-menu__submenu--classic m-menu__submenu--left m-menu__submenu--tabs" v-if="item.childs.length != 0">
						<span class="m-menu__arrow m-menu__arrow--adjust"></span>
						<ul v-if="item.childs.length > 0" class="m-menu__subnav">
							<router-link active-class="m-menu__item--active" tag="li" :to="getMenuLink(child)" v-for="child in item.childs" class="m-menu__item " m-menu-link-redirect="1" aria-haspopup="true">
								<a :href="getMenuLink(child)" class="m-menu__link ">
									<i v-if="child.icon !== ''" :class="'m-menu__link-icon ' + child.icon"></i>
									<span class="m-menu__link-text">{{getMenuAlias(child)}}</span>
								</a>
							</router-link>
						</ul>
					</div>
				</router-link>
			</ul>
		</div>
	</div>
	<!-- end::Horizontal Menu -->
</template>

<script>
    export default {
		data(){
	        return {
	            "menuItems": "",
	            "isShowSub": false,
	        }
	    },

	    mounted(){
	    	this.showChild();
	    },

	    created () {
	        this.getMenu();
	    },

	    methods: {
	        getMenu: async function(){
	            let menuObj = await window.axios.get("/admin-panel/menu");
	            menuObj = menuObj.data;

	            let parents = menuObj.data.filter((e)=>{ return e.parent_id == 0; });
	            this.menuItems = parents.map((e) => {
	            	let childs = menuObj.data.filter((c)=>{ return e.id == c.parent_id; });
	            	e.childs = childs;
	            	return e;
	            });
	            if(this.menuItems.length != 0) this.isShowSub = true;
	        },

	        getMenuLink: function(menuItem){
	    		let url = menuItem.resource !== "" ? "/" + menuItem.resource : "javascript:;";
	    		return url;
	    	},

	    	getMenuAlias: function(menuItem){
	    		let alias = menuItem.alias ? menuItem.alias : "";
	    		return alias;
	    	},

	    	showChild: function(){
	    		$(".m-menu__item").hover(
					function() {
						$(this).find(".m-menu__submenu").show();
					}, function() {
						$(this).find(".m-menu__submenu").hide();
					}
				);
	    	}
	    }
	}
</script>